import axios from 'axios';

/* 封装 get 方法 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get('/wget/' + url, {
      params: params
    }).then(res => {
      resolve(res)
    }).catch(err => {
      err = "Connected failed!"
      reject(err)
    })
  })
}

/* 封装 post 方法 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    if (window.usertype === 0 && url !== "login" && url !== "logout") {
      resolve({
        data: {
          code: -1000,
          msg: "Only super users are allowed to configure!"
        }
      })
      return
    }
    axios.post('/wpost/' + url, params).then(res => {
      if (res.data.code != undefined && res.data.msg !== undefined && url !== "login") {
        res.data.msg = (res.data.code === 0 ?
          "Config Successful!" :
          "Config failed, Reason, ") + res.data.msg
      }
      resolve(res)
    }).catch(err => {
      err = "Connected failed!"
      reject(err)
    })
  })
}